<div class="swap-flow-container flex column full-height p-16 gap-16">
  <!-- Swap Card -->
  <div class="swap-card flex column">
    <!-- Header -->
    <div class="swap-header flex justify-content-between align-items-center">
      <span class="swap-title">Swap</span>
      <kc-icon-button
        [icon]="'icon-settings'"
        [size]="'sm'"
        [variant]="'secondary'"
        [ariaLabel]="'Settings'"
        [title]="'Settings'"
        (buttonClick)="openSettingsModal()"
      />
    </div>

    <!-- Percentage Options -->
    <div class="percentage-options-wrapper flex justify-content-end">
      <div
        class="percentage-options flex gap-8"
        role="group"
        aria-label="Select percentage of balance"
      >
        @for (option of percentageOptions; track option.value) {
          <kc-button
            [text]="option.label"
            [variant]="'tag-secondary'"
            [isSelected]="selectedPercentage() === option.value"
            (buttonClick)="onPercentageClick($any(option.value))"
          />
        }
      </div>
    </div>

    <!-- Token Inputs Wrapper -->
    <div class="token-inputs-wrapper">
      <!-- SELL (From) -->
      <div class="token-input-box sell-box" [class.error]="fromInputError()">
        <div class="token-input-header">
          <span class="token-input-label">Sell</span>
          @if (fromToken()) {
            <span
              class="token-balance"
              [class.error-text]="isInsufficientBalance()"
            >
              Balance: {{ fromToken()?.balance | commaFormatter }}
            </span>
          }
        </div>
        <div class="token-input-row">
          <input
            type="text"
            inputmode="decimal"
            class="token-amount-input"
            [class.error]="fromInputError()"
            placeholder="0"
            [ngModel]="fromAmountInput()"
            (ngModelChange)="onFromAmountChange($event)"
          />
          <button class="token-select-btn" (click)="openTokenModal('from')">
            @if (fromToken()) {
              <kc-token-logo
                [ticker]="fromToken()!.symbol"
                [address]="fromToken()!.address"
                size="md"
              />
              <span class="token-symbol">{{ fromToken()?.symbol }}</span>
            } @else {
              <span class="select-token-text">Select</span>
            }
            <kc-icon iconClass="icon-chevron-down" size="xs" />
          </button>
        </div>
      </div>

      <!-- Switch Button -->
      <div class="switch-btn-container">
        <kc-icon-button
          [icon]="'icon-switch-vertical-01'"
          [size]="'sm'"
          [variant]="'default'"
          [ariaLabel]="'Switch tokens'"
          [title]="'Switch tokens'"
          (buttonClick)="switchTokens()"
        />
      </div>

      <!-- BUY (To) -->
      <div class="token-input-box buy-box">
        <div class="token-input-header">
          <span class="token-input-label">Buy</span>
          @if (toToken()) {
            <span class="token-balance">
              Balance: {{ toToken()?.balance | commaFormatter }}
            </span>
          }
        </div>
        <div class="token-input-row">
          <input
            type="text"
            inputmode="decimal"
            class="token-amount-input"
            placeholder="0"
            [ngModel]="toAmountInput()"
            (ngModelChange)="onToAmountChange($event)"
          />
          <button class="token-select-btn" (click)="openTokenModal('to')">
            @if (toToken()) {
              <kc-token-logo
                [ticker]="toToken()!.symbol"
                [address]="toToken()!.address"
                size="md"
              />
              <span class="token-symbol">{{ toToken()?.symbol }}</span>
            } @else {
              <span class="select-token-text">Select</span>
            }
            <kc-icon iconClass="icon-chevron-down" size="xs" />
          </button>
        </div>
        <!-- Min Received -->
        @if (!currentIsOutput() && minReceived()) {
          <div class="min-received">
            Min received: {{ minReceived() }} {{ toToken()?.symbol }}
          </div>
        }
      </div>
    </div>

    <!-- Trade Info -->
    @if (controllerState()?.tradeInfo?.route) {
      <div class="trade-info">
        <div class="trade-info-row">
          <span class="trade-info-label">Route</span>
          <span class="trade-info-value">{{ routePath() }}</span>
        </div>
      </div>
    }

    <!-- Swap Button -->
    <kc-button
      [text]="swapText()"
      [variant]="'primary'"
      [isFullWidth]="true"
      [isDisabled]="isSwapDisabled()"
      (buttonClick)="executeSwap()"
    />
  </div>
</div>
